{
	"addBill": "Ajouter une facture",
	"addBillSuccessNotification": "La facture a été créée avec succès",
	"addTransfer": "Ajouter un virement",
	"billFields": {
		"account": "Compte",
		"accountType": "Type de compte",
		"category": "Catégorie",
		"costCenter": "Centre de coûts",
		"description": "Description",
		"discount": "Réduction",
		"dueDate": "Date d'échéance",
		"filename": "exempledeCompte",
		"fine": "Bien",
		"interest": "Frais",
		"observation": "Commentaires",
		"payDate": "Date de paiement",
		"payed": "Payé ?",
		"paymentMethod": "Moyen de paiement",
		"performDate": "Date d'exécution",
		"reconciled": "Reconcilié",
		"supplier": "Fournisseur",
		"value": "Montant"
	},
	"competence": "Exécution",
	"dueDate": "Date d'échéance",
	"exportSpreadsheet": "Exporter tableau",
	"importSpreadsheet": "Importer tableau",
	"modalTransfer": {
		"add": "Ajouter un virement",
		"date": "Date",
		"description": "Description",
		"destinationAccount": "compte destinataire",
		"edit": "Modifier virement",
		"paid": "Payé ?",
		"sourceAccount": "Compte d'origine",
		"value": "Montant"
	},
	"printTitle": {
		"any": "Toutes les factures",
		"default": "Factures",
		"toPay": "Factures à payer",
		"toReceive": "Factures à recevoir",
		"transfer": "Virement"
	},
	"printTitleCaps": {
		"any": "TOUTES LES FACTURES",
		"toPay": "FACTURES À PAYER",
		"toReceive": "FACTURES À RECEVOIR",
		"transfer": "VIREMENT"
	},
	"tableBill": {
		"account": "Compte",
		"description": "Description",
		"dueDate": "Date d'échéance",
		"expireToday": "Expire aujourd'hui",
		"expired": "Expiré",
		"notInformed": "Non informé",
		"paid": "Payé ?",
		"performDate": "Date d'exécution",
		"value": "Montant"
	},
	"tableTransfer": {
		"actions": "Actions",
		"date": "Date",
		"description": "Description",
		"destinationAccount": "Compte destinataire",
		"paid": "Payé ?",
		"popConfirm": "Êtes-vous sûr de vouloir supprimer ce virment ?",
		"sourceAccount": "Compte d'origine",
		"value": "Montant"
	}
}
